import { render, staticRenderFns } from "./PacoteExames.vue?vue&type=template&id=3395f8c1&scoped=true"
import script from "./PacoteExames.vue?vue&type=script&lang=js"
export * from "./PacoteExames.vue?vue&type=script&lang=js"
import style0 from "./PacoteExames.vue?vue&type=style&index=0&id=3395f8c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3395f8c1",
  null
  
)

export default component.exports